export var ChargerAssetLinkUpdateRequest;
(function (ChargerAssetLinkUpdateRequest) {
    /**
     * The new status to set for the charger link.
     */
    let status;
    (function (status) {
        status["ACTIVE"] = "ACTIVE";
        status["DEACTIVATED"] = "DEACTIVATED";
        status["EXPIRED"] = "EXPIRED";
    })(status = ChargerAssetLinkUpdateRequest.status || (ChargerAssetLinkUpdateRequest.status = {}));
})(ChargerAssetLinkUpdateRequest || (ChargerAssetLinkUpdateRequest = {}));
